const map = {
	"./account-prof-pic-48-48.svg": 6429,
	"./account-prof-pic.svg": 9007,
	"./arrow_back.svg": 4064,
	"./default-logo.svg": 8326,
	"./delete-icon.svg": 7348,
	"./edit_primary_icon.svg": 5728,
	"./empty-screen-img.svg": 2945,
	"./favicon-icons/apple-icon-60x60.png": 1922,
	"./main-logo.svg": 5700,
	"./menu-dots-icon.svg": 8531,
	"./ota-updates-icon-download.svg": 433,
	"./sidebar-icons/client-icon.svg": 9128,
	"./sidebar-icons/dashboard-icon-filled.svg": 8082,
	"./sidebar-icons/dashboard-icon.svg": 3633,
	"./sidebar-icons/ota-updates-icon-upload.svg": 4326
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;